(function () {

    /*
    |--------------------------------------------------------------------------
    | CONFIG
    |--------------------------------------------------------------------------
    */

    const MAX_PRODUCTS = 4;

    let updateTimer = null;
    let isUpdating = false;
    let lastCartSignature = null;


    /*
    |--------------------------------------------------------------------------
    | COLLECTIONS
    |--------------------------------------------------------------------------
    */

    const collections = {

        /*
        |--------------------------------------------------------------------------
        | WOMEN
        |--------------------------------------------------------------------------
        */

        women: {

            'Рокля': 'рокли-и-поли',
            'Пола': 'рокли-и-поли',

            'Тениска': 'потници-и-тениски',
            'горнище': 'потници-и-тениски',

            'Дънки': 'дънки-и-панталони',
            'Панталон': 'дънки-и-панталони',
            'клин': 'дънки-и-панталони',

            'Блуза': 'блузи-и-ризи',
            'Риза': 'блузи-и-ризи',

            'Сако': 'сака',

            'Яке': 'якета',
            'Елек': 'якета',
            'Палто': 'якета',

            'жилетка': 'пуловери-и-жилетки',
            'пуловер': 'пуловери-и-жилетки',

            'Екип': 'екипи',
            'Гащеризон': 'екипи',

            'колан': 'аксесоари',
            'чанта': 'аксесоари'

        },


        /*
        |--------------------------------------------------------------------------
        | MEN
        |--------------------------------------------------------------------------
        */

        men: {

            'Дънки': 'мъжки-дънки-и-панталони',
            'Панталон': 'мъжки-дънки-и-панталони',

            'Блуза': 'мъжки-блузи-и-ризи',
            'Риза': 'мъжки-блузи-и-ризи',

            'Тениска': 'мъжки-тениски',

            'горнище': 'мъжки-блузи-и-ризи',

            'Яке': 'мъжки-якета-и-елеци',
            'Елек': 'мъжки-якета-и-елеци',

            'чанта': 'мъжки-чанти-и-аксесоари',
            'колан': 'мъжки-чанти-и-аксесоари'

        }

    };


    /*
    |--------------------------------------------------------------------------
    | CROSS SELL MAP
    |--------------------------------------------------------------------------
    |
    | Product type -> product types that complement it
    |
    |--------------------------------------------------------------------------
    */

    const crossSellMap = {

        'Блуза': [
            'Дънки',
            'Панталон',
            'Пола',
            'Сако',
            'чанта'
        ],

        'Гащеризон': [
            'Сако',
            'Яке',
            'жилетка',
            'чанта'
        ],

        'горнище': [
            'Дънки',
            'Панталон',
            'Пола',
            'Тениска'
        ],

        'Дънки': [
            'Тениска',
            'Блуза',
            'Риза',
            'Сако',
            'колан',
            'чанта'
        ],

        'Екип': [
            'Тениска',
            'горнище',
            'Яке',
            'чанта'
        ],

        'Елек': [
            'Тениска',
            'Блуза',
            'Риза',
            'Дънки'
        ],

        'жилетка': [
            'Тениска',
            'Риза',
            'Дънки',
            'Панталон'
        ],

        'клин': [
            'Тениска',
            'Блуза',
            'горнище',
            'Яке'
        ],

        'колан': [
            'Дънки',
            'Панталон',
            'Пола',
            'Рокля'
        ],

        'Палто': [
            'пуловер',
            'Риза',
            'Панталон',
            'Дънки'
        ],

        'Панталон': [
            'Тениска',
            'Блуза',
            'Риза',
            'Сако',
            'колан'
        ],

        'Пола': [
            'Блуза',
            'Тениска',
            'Риза',
            'Сако',
            'чанта'
        ],

        'пуловер': [
            'Дънки',
            'Панталон',
            'Пола',
            'Риза'
        ],

        'Риза': [
            'Дънки',
            'Панталон',
            'Пола',
            'Сако'
        ],

        'Рокля': [
            'Сако',
            'жилетка',
            'чанта',
            'колан'
        ],

        'рокля': [
            'Сако',
            'жилетка',
            'чанта',
            'колан'
        ],

        'Сако': [
            'Тениска',
            'Блуза',
            'Риза',
            'Дънки',
            'Панталон'
        ],

        'Тениска': [
            'Дънки',
            'Панталон',
            'Пола',
            'Сако',
            'чанта'
        ],

        'чанта': [
            'Рокля',
            'Дънки',
            'Пола',
            'Панталон'
        ],

        'Яке': [
            'Тениска',
            'Дънки',
            'Панталон',
            'пуловер'
        ]

    };


    /*
    |--------------------------------------------------------------------------
    | FORMAT MONEY
    |--------------------------------------------------------------------------
    */

    function formatMoney(cents) {

        return '€' +
            (Number(cents) / 100).toFixed(2);

    }


    /*
    |--------------------------------------------------------------------------
    | CART SIGNATURE
    |--------------------------------------------------------------------------
    */

    function createCartSignature(cart) {

        if (
            !cart ||
            !cart.items
        ) {

            return '';

        }


        return cart.items
            .map(function (item) {

                return (
                    item.product_id +
                    ':' +
                    item.quantity
                );

            })
            .sort()
            .join('|');

    }


    /*
    |--------------------------------------------------------------------------
    | LOAD CART
    |--------------------------------------------------------------------------
    */

    function loadCart() {

        return fetch(
            window.Shopify.routes.root +
            'cart.js'
        )

        .then(function (response) {

            if (!response.ok) {

                throw new Error(
                    'Unable to load cart.'
                );

            }

            return response.json();

        });

    }


    /*
    |--------------------------------------------------------------------------
    | LOAD COLLECTION PRODUCTS
    |--------------------------------------------------------------------------
    */

    function loadCollectionProducts(
        collectionHandle
    ) {

        const url =
            window.Shopify.routes.root +
            'collections/' +
            encodeURIComponent(
                collectionHandle
            ) +
            '/products.json?limit=20';


        return fetch(url)

        .then(function (response) {

            if (!response.ok) {

                throw new Error(
                    'Collection request failed: ' +
                    collectionHandle
                );

            }

            return response.json();

        })

        .then(function (data) {

            return data.products || [];

        })

        .catch(function (error) {

            console.error(
                'Collection error:',
                collectionHandle,
                error
            );

            return [];

        });

    }


    /*
    |--------------------------------------------------------------------------
    | LOAD FULL PRODUCT
    |--------------------------------------------------------------------------
    |
    | Used to get:
    |
    | - image
    | - price
    | - variants
    | - product URL
    |
    |--------------------------------------------------------------------------
    */

    function loadFullProduct(handle) {

        return fetch(
            window.Shopify.routes.root +
            'products/' +
            encodeURIComponent(
                handle
            ) +
            '.js'
        )

        .then(function (response) {

            if (!response.ok) {

                throw new Error(
                    'Unable to load product: ' +
                    handle
                );

            }

            return response.json();

        })

        .catch(function (error) {

            console.error(
                'Product error:',
                handle,
                error
            );

            return null;

        });

    }


    /*
    |--------------------------------------------------------------------------
    | DETERMINE GENDER
    |--------------------------------------------------------------------------
    */

function determineCartGender(cart) {

    let womenScore = 0;
    let menScore = 0;


    const womenKeywords = [
        'дамски',
        'дамска',
        'дамско',
        'дамският',
        'дамската',
        'дамското'
    ];


    const menKeywords = [
        'мъжки',
        'мъжка',
        'мъжко',
        'мъжкият',
        'мъжката',
        'мъжкото'
    ];


    cart.items.forEach(function (item) {

        const handle = (
            item.handle ||
            ''
        ).toLowerCase();


        const title = (
            item.product_title ||
            item.title ||
            ''
        ).toLowerCase();


        const productType = (
            item.product_type ||
            ''
        ).toLowerCase();


        const productText =
            handle +
            ' ' +
            title +
            ' ' +
            productType;


        womenKeywords.forEach(
            function (keyword) {

                if (
                    productText.includes(
                        keyword
                    )
                ) {

                    womenScore += 10;

                }

            }
        );


        menKeywords.forEach(
            function (keyword) {

                if (
                    productText.includes(
                        keyword
                    )
                ) {

                    menScore += 10;

                }

            }
        );

    });


    console.log(
        'Cart gender scores:',
        {
            women: womenScore,
            men: menScore
        }
    );


    return {

        women:
            womenScore,

        men:
            menScore,

        mixed:
            womenScore > 0 &&
            menScore > 0

    };

}


    /*
    |--------------------------------------------------------------------------
    | GET RECOMMENDED TYPES
    |--------------------------------------------------------------------------
    */

    function getRecommendedTypes(cart) {

        const cartTypes =
            cart.items

                .map(function (item) {

                    return item.product_type;

                })

                .filter(Boolean);


        const recommendedTypes = [];


        cartTypes.forEach(
            function (type) {

                const recommendations =
                    crossSellMap[type] || [];


                recommendations.forEach(
                    function (recommendedType) {

                        /*
                        |--------------------------------------------------------------------------
                        | Don't recommend a category already in cart
                        |--------------------------------------------------------------------------
                        */

                        if (
                            cartTypes.includes(
                                recommendedType
                            )
                        ) {

                            return;

                        }


                        if (
                            !recommendedTypes.includes(
                                recommendedType
                            )
                        ) {

                            recommendedTypes.push(
                                recommendedType
                            );

                        }

                    }
                );

            }
        );


        return recommendedTypes;

    }


    /*
    |--------------------------------------------------------------------------
    | FIND RECOMMENDED PRODUCTS
    |--------------------------------------------------------------------------
    */

function findRecommendedProducts(
    cart,
    genderData
) {

    const cartTypes =
        cart.items

            .map(function (item) {

                return item.product_type;

            })

            .filter(Boolean);


    /*
    |--------------------------------------------------------------------------
    | Products already in cart
    |--------------------------------------------------------------------------
    */

    const cartProductIds =
        cart.items.map(
            function (item) {

                return String(
                    item.product_id
                );

            }
        );


    /*
    |--------------------------------------------------------------------------
    | Determine recommendation groups
    |--------------------------------------------------------------------------
    */

    let genders = [];


    /*
    |--------------------------------------------------------------------------
    | MIXED CART
    |--------------------------------------------------------------------------
    */

    if (
        genderData.mixed
    ) {

        genders = [
            {
                gender: 'women',
                amount: 2
            },
            {
                gender: 'men',
                amount: 2
            }
        ];

    }


    /*
    |--------------------------------------------------------------------------
    | WOMEN ONLY
    |--------------------------------------------------------------------------
    */

    else if (
        genderData.women > 0
    ) {

        genders = [
            {
                gender: 'women',
                amount: 4
            }
        ];

    }


    /*
    |--------------------------------------------------------------------------
    | MEN ONLY
    |--------------------------------------------------------------------------
    */

    else if (
        genderData.men > 0
    ) {

        genders = [
            {
                gender: 'men',
                amount: 4
            }
        ];

    }


    /*
    |--------------------------------------------------------------------------
    | FALLBACK
    |--------------------------------------------------------------------------
    */

    else {

        genders = [
            {
                gender: 'women',
                amount: 4
            }
        ];

    }


    /*
    |--------------------------------------------------------------------------
    | Get recommended product types
    |--------------------------------------------------------------------------
    */

    const recommendedTypes =
        getRecommendedTypes(
            cart
        );


    console.log(
        'Recommended types:',
        recommendedTypes
    );


    if (
        !recommendedTypes.length
    ) {

        return Promise.resolve([]);

    }


    /*
    |--------------------------------------------------------------------------
    | Build collection requests
    |--------------------------------------------------------------------------
    */

    const requests = [];


    genders.forEach(
        function (genderDataItem) {

            const gender =
                genderDataItem.gender;


            const amount =
                genderDataItem.amount;


            recommendedTypes.forEach(
                function (type) {

                    const collectionHandle =
                        collections[gender][type];


                    if (
                        !collectionHandle
                    ) {

                        return;

                    }


                    requests.push({

                        gender:
                            gender,

                        amount:
                            amount,

                        type:
                            type,

                        promise:
                            loadCollectionProducts(
                                collectionHandle
                            )

                    });

                }
            );

        }
    );


    /*
    |--------------------------------------------------------------------------
    | Load all collections
    |--------------------------------------------------------------------------
    */

    return Promise.all(
        requests.map(
            function (request) {

                return request.promise
                    .then(
                        function (products) {

                            return {

                                gender:
                                    request.gender,

                                amount:
                                    request.amount,

                                type:
                                    request.type,

                                products:
                                    products

                            };

                        }
                    );

            }
        )
    )

    .then(function (results) {

        const selected = [];

        const selectedIds =
            new Set();


        /*
        |--------------------------------------------------------------------------
        | Select products per gender
        |--------------------------------------------------------------------------
        */

        genders.forEach(
            function (genderDataItem) {

                const gender =
                    genderDataItem.gender;


                const amount =
                    genderDataItem.amount;


                const genderResults =
                    results.filter(
                        function (result) {

                            return (
                                result.gender ===
                                gender
                            );

                        }
                    );


                /*
                |--------------------------------------------------------------------------
                | Shuffle collections
                |--------------------------------------------------------------------------
                */

                genderResults.sort(
                    function () {

                        return (
                            0.5 -
                            Math.random()
                        );

                    }
                );


                /*
                |--------------------------------------------------------------------------
                | First pass:
                | one product per category
                |--------------------------------------------------------------------------
                */

                genderResults.forEach(
                    function (result) {

                        if (
                            selected.filter(
                                function (product) {

                                    return (
                                        product.__gender ===
                                        gender
                                    );

                                }
                            ).length >= amount
                        ) {

                            return;

                        }


                        const candidates =
                            result.products
                                .filter(
                                    function (product) {

                                        return (
                                            !cartProductIds.includes(
                                                String(
                                                    product.id
                                                )
                                            ) &&
                                            !selectedIds.has(
                                                String(
                                                    product.id
                                                )
                                            )
                                        );

                                    }
                                );


                        if (
                            !candidates.length
                        ) {

                            return;

                        }


                        candidates.sort(
                            function () {

                                return (
                                    0.5 -
                                    Math.random()
                                );

                            }
                        );


                        const product =
                            candidates[0];


                        const id =
                            String(
                                product.id
                            );


                        selectedIds.add(
                            id
                        );


                        product.__gender =
                            gender;


                        selected.push(
                            product
                        );

                    }
                );


                /*
                |--------------------------------------------------------------------------
                | Second pass:
                | fill remaining slots
                |--------------------------------------------------------------------------
                */

                if (
                    selected.filter(
                        function (product) {

                            return (
                                product.__gender ===
                                gender
                            );

                        }
                    ).length < amount
                ) {

                    const allProducts = [];


                    genderResults.forEach(
                        function (result) {

                            result.products.forEach(
                                function (product) {

                                    allProducts.push(
                                        product
                                    );

                                }
                            );

                        }
                    );


                    allProducts.sort(
                        function () {

                            return (
                                0.5 -
                                Math.random()
                            );

                        }
                    );


                    allProducts.forEach(
                        function (product) {

                            const genderCount =
                                selected.filter(
                                    function (selectedProduct) {

                                        return (
                                            selectedProduct.__gender ===
                                            gender
                                        );

                                    }
                                ).length;


                            if (
                                genderCount >=
                                amount
                            ) {

                                return;

                            }


                            const id =
                                String(
                                    product.id
                                );


                            if (
                                cartProductIds.includes(
                                    id
                                )
                            ) {

                                return;

                            }


                            if (
                                selectedIds.has(
                                    id
                                )
                            ) {

                                return;

                            }


                            selectedIds.add(
                                id
                            );


                            product.__gender =
                                gender;


                            selected.push(
                                product
                            );

                        }
                    );

                }

            }
        );


        /*
        |--------------------------------------------------------------------------
        | If mixed cart and one gender couldn't
        | provide enough products, fill remaining
        |--------------------------------------------------------------------------
        */

        if (
            selected.length <
            MAX_PRODUCTS
        ) {

            const allResults =
                results.slice();


            allResults.sort(
                function () {

                    return (
                        0.5 -
                        Math.random()
                    );

                }
            );


            allResults.forEach(
                function (result) {

                    result.products.forEach(
                        function (product) {

                            if (
                                selected.length >=
                                MAX_PRODUCTS
                            ) {

                                return;

                            }


                            const id =
                                String(
                                    product.id
                                );


                            if (
                                cartProductIds.includes(
                                    id
                                )
                            ) {

                                return;

                            }


                            if (
                                selectedIds.has(
                                    id
                                )
                            ) {

                                return;

                            }


                            selectedIds.add(
                                id
                            );


                            product.__gender =
                                result.gender;


                            selected.push(
                                product
                            );

                        }
                    );

                }
            );

        }


        /*
        |--------------------------------------------------------------------------
        | Remove internal property
        |--------------------------------------------------------------------------
        */

        selected.forEach(
            function (product) {

                delete product.__gender;

            }
        );


        return selected.slice(
            0,
            MAX_PRODUCTS
        );

    });

}



    /*
    |--------------------------------------------------------------------------
    | RENDER PRODUCTS
    |--------------------------------------------------------------------------
    */

    function renderProducts(
        products,
        container,
        grid
    ) {

        if (
            !products.length
        ) {

            container.style.display =
                'none';

            return;

        }


        container.style.display =
            '';


        grid.innerHTML =
            '';


        products.forEach(
            function (product) {

                const card =
                    document.createElement(
                        'div'
                    );


                card.className =
                    'cart-recommendation';


                const image =
                    product.featured_image ||
                    (
                        product.images &&
                        product.images[0]
                    ) ||
                    '';


                const price =
                    product.price;


                card.innerHTML = `

                    <a
                        href="${product.url}"
                        class="cart-recommendation__image"
                    >

                        ${
                            image
                                ? `
                                    <img
                                        src="${image}"
                                        alt="${product.title}"
                                        loading="lazy"
                                    >
                                  `
                                : ''
                        }

                    </a>


                    <a
                        href="${product.url}"
                        class="cart-recommendation__title"
                    >
                        ${product.title}
                    </a>


                    <div
                        class="cart-recommendation__price"
                    >
                        ${formatMoney(price)}
                    </div>


                    <a
                        href="${product.url}"
                        class="cart-recommendation__add"
                    >
                        РАЗГЛЕДАЙ
                    </a>

                `;


                grid.appendChild(
                    card
                );

            }
        );

    }


    /*
    |--------------------------------------------------------------------------
    | UPDATE RECOMMENDATIONS
    |--------------------------------------------------------------------------
    */

    function updateRecommendations() {

        clearTimeout(
            updateTimer
        );


        updateTimer =
            setTimeout(
                performRecommendationUpdate,
                150
            );

    }


    /*
    |--------------------------------------------------------------------------
    | PERFORM UPDATE
    |--------------------------------------------------------------------------
    */

    function performRecommendationUpdate() {

        if (isUpdating) {
            return;
        }


        const container =
            document.querySelector(
                '[data-cart-recommendations]'
            );


        if (!container) {
            return;
        }


        const grid =
            container.querySelector(
                '[data-recommendations-grid]'
            );


        if (!grid) {
            return;
        }


        isUpdating =
            true;


        loadCart()

        .then(function (cart) {

            /*
            |--------------------------------------------------------------------------
            | EMPTY CART
            |--------------------------------------------------------------------------
            */

            if (
                !cart.items ||
                !cart.items.length
            ) {

                container.style.display =
                    'none';

                lastCartSignature =
                    '';

                return [];

            }


            /*
            |--------------------------------------------------------------------------
            | CART SIGNATURE
            |--------------------------------------------------------------------------
            */

            const signature =
                createCartSignature(
                    cart
                );


            /*
            |--------------------------------------------------------------------------
            | Nothing changed
            |--------------------------------------------------------------------------
            */

            if (
                signature ===
                lastCartSignature
            ) {

                return null;

            }


            lastCartSignature =
                signature;


            /*
            |--------------------------------------------------------------------------
            | GENDER
            |--------------------------------------------------------------------------
            */

            const genderData =
                determineCartGender(
                    cart
                );


            /*
            |--------------------------------------------------------------------------
            | FIND PRODUCTS
            |--------------------------------------------------------------------------
            */

            return findRecommendedProducts(
                cart,
                genderData
            );

        })

        .then(function (products) {

            /*
            |--------------------------------------------------------------------------
            | Cart didn't change.
            |--------------------------------------------------------------------------
            */

            if (
                products === null
            ) {

                return null;

            }


            /*
            |--------------------------------------------------------------------------
            | No recommendations
            |--------------------------------------------------------------------------
            */

            if (
                !products ||
                !products.length
            ) {

                renderProducts(
                    [],
                    container,
                    grid
                );

                return null;

            }


            /*
            |--------------------------------------------------------------------------
            | Load full product data
            |--------------------------------------------------------------------------
            */

            return Promise.all(
                products.map(
                    function (product) {

                        return loadFullProduct(
                            product.handle
                        );

                    }
                )
            );

        })

        .then(function (products) {

            if (
                !products
            ) {

                return;

            }


            const validProducts =
                products.filter(
                    function (product) {

                        return (
                            product !== null
                        );

                    }
                );


            renderProducts(
                validProducts.slice(
                    0,
                    MAX_PRODUCTS
                ),
                container,
                grid
            );

        })

        .catch(function (error) {

            console.error(
                'Recommendation update error:',
                error
            );

        })

        .finally(function () {

            isUpdating =
                false;

        });

    }


    /*
    |--------------------------------------------------------------------------
    | CART EVENTS
    |--------------------------------------------------------------------------
    */

    document.addEventListener(
        'cart:updated',
        function () {

            lastCartSignature =
                null;

            updateRecommendations();

        }
    );


    document.addEventListener(
        'cart:change',
        function () {

            lastCartSignature =
                null;

            updateRecommendations();

        }
    );


    document.addEventListener(
        'cart:update',
        function () {

            lastCartSignature =
                null;

            updateRecommendations();

        }
    );


    /*
    |--------------------------------------------------------------------------
    | SHOPIFY SECTION LOAD
    |--------------------------------------------------------------------------
    */

    document.addEventListener(
        'shopify:section:load',
        function () {

            lastCartSignature =
                null;

            updateRecommendations();

        }
    );


    /*
    |--------------------------------------------------------------------------
    | INITIAL LOAD
    |--------------------------------------------------------------------------
    */

    document.addEventListener(
        'DOMContentLoaded',
        function () {

            lastCartSignature =
                null;

            updateRecommendations();

        }
    );


    /*
    |--------------------------------------------------------------------------
    | FALLBACK WATCHER
    |--------------------------------------------------------------------------
    |
    | Some themes don't dispatch cart events.
    | We therefore check the cart periodically.
    |
    |--------------------------------------------------------------------------
    */

    setInterval(
        function () {

            updateRecommendations();

        },
        1200
    );


})();